import { string } from "prop-types";

import styled from "styled-components/macro";

import { colors } from "UI/colors";

// A tight inline FontAwesome glyph for the verification chips' small icons (the
// admin checkmark). FnrContainedIcon is the wrong tool here: its container box
// is sized off the size token, so a glyph capped below that token (a check
// shrunk to the label's cap height) both inflated the chip's height and floated
// off-center inside the oversized box. This span hugs the glyph instead, so the
// chip stays compact and the row's `align-items: center` centers the icon with
// the label. Callers cap the visual size via `fontSize`.
//
// The big USPS eagle still uses FnrContainedIcon (see UspsVerifiedPill) — it
// fills its token box, so the container suits it.

// Mirror FnrIcon's class derivation: prefix the glyph token with `fa-` unless it
// already carries it, and leave the style tokens (fas/far/fab/…) untouched.
const STYLE_TOKENS = ["fas", "far", "fab", "fal", "fad", "fat"];
const toFaClass = (icon) =>
  icon
    .split(" ")
    .map((token) =>
      token.startsWith("fa-") || STYLE_TOKENS.includes(token)
        ? token
        : `fa-${token}`
    )
    .join(" ");

const ChipGlyph = ({ icon, fontSize }) => (
  <Glyph className={toFaClass(icon)} aria-hidden="true" style={{ fontSize }} />
);

ChipGlyph.propTypes = {
  icon: string,
  // A CSS length capping the glyph; e.g. "0.5em" of the chip's base.
  fontSize: string,
};

export default ChipGlyph;

// line-height: 1 keeps the box tight to the glyph so it can't add line-box
// leading to the chip's height. The text-stroke restores visual weight lost when
// the glyph is shrunk to cap height — at ~6px even FA's heaviest (solid/900)
// class reads thin, so a hairline same-color stroke thickens the strokes back
// up. (No heavier FA weight class exists above solid.)
const Glyph = styled.span`
  line-height: 1;
  color: ${colors.fnBlue};
  -webkit-text-stroke: 0.4px currentColor;
`;
